import { SxProps, Theme } from '@mui/material'

export interface CheckSettingsFormFieldsCommonProps {
  disabled?: boolean
  memberCheckSettingsSelectedPath?: string
  compact?: boolean
}

export const getCheckSettingsStackSpacing = (compact?: boolean, defaultSpacing = 1): number =>
  compact ? 0.5 : defaultSpacing

export const getCheckSettingsGridSpacing = (compact?: boolean): number => (compact ? 0.75 : 2)

export const getCheckSettingsMaxWidth = (compact?: boolean): string | undefined =>
  compact ? undefined : '1000px'

export const compactCheckSettingsFormSx: SxProps<Theme> = {
  '& .MuiFormControl-root > .MuiBox-root .MuiTypography-root': {
    fontSize: 13,
    fontWeight: 500,
    mb: 0.25,
  },
  '& .MuiInputBase-input': {
    fontSize: 13,
    py: 0.35,
  },
  '& .MuiInputAdornment-root': {
    fontSize: 13,
  },
  '& .MuiCheckbox-root': {
    p: 0.25,
  },
  '& .MuiCheckbox-root .MuiSvgIcon-root': {
    fontSize: 18,
  },
  '& .MuiCheckbox-root + .MuiTypography-root': {
    fontSize: 13,
    px: 0.5,
  },
}
